import { ColumnPattern } from "@/common/components/Table";

export const maintenanceForwardingsTableColumns: ColumnPattern[] = [
  { value: 'protocol_number', label: 'Processo de Manutenção' },
  { value: 'forwarding', label: 'Encaminhamento atual' },
  { value: 'equipment', label: 'Equipamento' },
  { value: 'company', label: 'Empresa' },
  { value: 'actions', label: 'Ações', className: 'w-11' },
];
